import { Injectable } from '@angular/core';
import { RepositoryService } from '../repository/repository.service';
import { Observable, Subscription } from 'rxjs';
import { BroadcastService } from '../broadcast/broadcast.service';
import { CommonEvents } from '../../enums/common-events.enum';
import { IInsertToCacheEvent } from '../../interfaces/iinsert-to-cache-event';
import { environment } from '../../../../../environments/environment.prod';
import { SwEvents } from '../../enums/sw-events.enum';
import { NotificationIndexDb } from '../../../portal/models/notification-indexdb.model';

@Injectable({
    providedIn: 'root'
})
export class CachingService {

    private schemaName = 'app-cache';
    private insertToCacheSubscription: Subscription;

    constructor(private repositoryService: RepositoryService,
                private broadcastService: BroadcastService) {

        this.insertToCacheSubscription = broadcastService.on(CommonEvents.InsertToCache)
            .subscribe((data: IInsertToCacheEvent) => this.putToCache(data));

        if (environment.production) {
            this.encryptNotifications();
            this.listenToChangeNotificationFromServiceWorker();
        }
    }

    private listenToChangeNotificationFromServiceWorker() {
        navigator.serviceWorker?.addEventListener('message', event => {
            if (event.data.method === SwEvents.NotificationUpdate) {
                this.encryptNotifications();
            }
        });
    }

    public encryptNotifications() {
        this.getAll(false).subscribe((indexDbData: NotificationIndexDb[]) => {
            const notifications: NotificationIndexDb[] = indexDbData
                .filter(data => data && data.id && data.id.startsWith('notification_') && data.valid === 'false')
                .map(notification => {
                    return {...notification, data: JSON.parse(atob(notification.data as any))};
                });

            const removeNotificationIds: string[] = notifications.map(notification => notification.id);
            this.deleteKeys(removeNotificationIds);


            notifications.forEach(notification => {
                const newNotification = notification;
                this.put(newNotification.id, newNotification.data);
            });
        });
    }

    public get<T>(id: string): Observable<T> {
        return new Observable(
            subscriber => this.repositoryService
                .get(this.schemaName, id)
                .subscribe(data => subscriber.next(data as T))
        );
    }

    public getAll(decripted: boolean): Observable<any> {
        return new Observable(
            subscriber => this.repositoryService
                .getAll(this.schemaName, decripted)
                .subscribe(data => subscriber.next(data))
        );
    }

    public put(id: string, body: any) {
        this.repositoryService.put(this.schemaName, id, body);
    }

    public deleteKeys(userCacheEntries: string[]) {
        userCacheEntries.forEach(id => this.repositoryService.delete(this.schemaName, id));
    }

    private putToCache(ev: IInsertToCacheEvent) {
        this.put(ev.cacheId, ev.body);
    }

}
